import { Modal } from 'antd';

import { COLOR } from '@/shared/design-tokens/design-tokens';
import { MODAL_FOOTER_BUTTON_SIZE, MODAL_WIDTHS } from '@/shared/lib/constants';
import { Button } from '@/shared/ui/Button';
import { Icon } from '@/shared/ui/Icon';

import styles from '@/features/connectors/ui/_internal/connectorModal.module.css';

type DeleteConnectorsModalProps = {
  open: boolean;
  selectedCount: number;
  confirmLoading: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
};

export const DeleteConnectorsModal = ({
  open,
  selectedCount,
  confirmLoading,
  onConfirm,
  onCancel,
}: DeleteConnectorsModalProps) => {
  const footer = (
    <>
      <Button variant="outlined" color="standard" onClick={onCancel} {...MODAL_FOOTER_BUTTON_SIZE}>
        취소
      </Button>
      <Button
        variant="critical"
        color="critical"
        loading={confirmLoading}
        onClick={onConfirm}
        {...MODAL_FOOTER_BUTTON_SIZE}>
        삭제
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      centered
      closable={false}
      title={null}
      footer={footer}
      width={MODAL_WIDTHS.CONFIRM_ALERT}
      onCancel={onCancel}>
      <div className={styles.popupBody}>
        <div className={styles.popupIcon}>
          <Icon name="trash" size={32} color={COLOR.GRAY[10]} />
        </div>
        <p className={styles.popupDescription}>{selectedCount} 개의 Data Source Connector 를 삭제 하시겠습니까?</p>
        <p className={styles.popupDescription}>삭제하는 경우, 더 이상 해당 데이터는 수집되지 않습니다.</p>
      </div>
    </Modal>
  );
};
